
// Variant picker -> update hidden id + price + add-to-cart state
document.querySelectorAll('[data-product-form]').forEach(function(form){
  var data = JSON.parse(form.querySelector('[data-variants]').textContent);
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-price]');
  var btn = form.querySelector('[data-add]');
  function money(cents){ return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function selected(){
    var val = form.querySelector('input[name="opt"]:checked');
    return val ? val.value : (data[0] && data[0].title);
  }
  function update(){
    var t = selected();
    var v = data.find(function(x){ return x.title === t; }) || data[0];
    if(!v) return;
    idInput.value = v.id;
    if(priceEl) priceEl.textContent = form.dataset.currency + ' ' + money(v.price);
    if(btn){ btn.disabled = false; btn.textContent = 'Add to cart'; }
  }
  form.querySelectorAll('input[name="opt"]').forEach(function(r){ r.addEventListener('change', update); });
  update();
});
